export const selectUid = ({firebase}) => firebase.auth.uid
